import { render, staticRenderFns } from "./NetShop.vue?vue&type=template&id=01e03c79&scoped=true"
import script from "./NetShop.vue?vue&type=script&lang=js"
export * from "./NetShop.vue?vue&type=script&lang=js"
import style0 from "./NetShop.vue?vue&type=style&index=0&id=01e03c79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e03c79",
  null
  
)

export default component.exports